<template>
  <v-dialog :value="open" max-width="380" @click:outside="$emit('close')" @keydown.esc="$emit('close')">
    <v-card style="border-radius:12px;">
      <v-card-title style="font-size:15px;font-weight:700;color:#2d3748;padding:16px 16px 8px;">Popust na račun</v-card-title>
      <v-card-text>
        <v-text-field
          ref="rateInput"
          :value="parseFloat(rate).toFixed(2)"
          label="Popust %"
          type="number" min="0" max="100" step="1"
          outlined dense suffix="%"
          class="disc-input"
          :error="rate > 100"
          :error-messages="rate > 100 ? 'Popust ne može biti veći od 100%' : ''"
          @focus="$event.target.select()"
          @blur="v => rate = parseFloat(v.target.value) || 0"
          @keydown.enter="e => { rate = parseFloat(e.target.value) || 0; $nextTick(() => { if (rate <= 100) save() }) }"
        />
      </v-card-text>
      <v-card-actions style="padding:8px 16px 16px;gap:8px;">
        <v-btn text small color="#E53935" @click="() => { $emit('save', null); $emit('close') }">Ukloni popust</v-btn>
        <v-spacer />
        <v-btn text small @click="$emit('close')">Odustani</v-btn>
        <v-btn small depressed
          :disabled="rate > 100"
          style="background:rgba(0,188,212,0.1);color:#00BCD4;border:1px solid rgba(0,188,212,0.3);border-radius:8px;"
          @click="save"
        >Primijeni</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ShopDiscountModal',
  props: {
    open: { type: Boolean, default: false },
    currentRate: { type: Number, default: 0 }
  },
  data () { return { rate: 0 } },
  watch: {
    open (val) {
      if (val) {
        this.rate = this.currentRate || 0
        setTimeout(() => {
          const input = this.$refs.rateInput && this.$refs.rateInput.$el.querySelector('input')
          if (input) { input.focus(); input.select() }
        }, 150)
      }
    }
  },
  methods: {
    save () {
      if (this.rate > 100) return
      if (!this.rate || this.rate <= 0) {
        this.$emit('save', null)
      } else {
        this.$emit('save', { type: 'RATE', rate: this.rate })
      }
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.disc-input >>> .v-input__slot { border-radius: 8px !important; background: #F8FAFC !important; }
.disc-input >>> fieldset { border-color: #E2E8F0 !important; border-radius: 8px !important; }
.disc-input >>> .v-input__slot:hover fieldset { border-color: #00BCD4 !important; }
.disc-input.v-input--is-focused >>> fieldset { border-color: #00BCD4 !important; border-width: 2px !important; }
.disc-input >>> input[type=number]::-webkit-outer-spin-button,
.disc-input >>> input[type=number]::-webkit-inner-spin-button { -webkit-appearance: none; margin: 0; }
.disc-input >>> input[type=number] { -moz-appearance: textfield; }
</style>
